// App.js
import "./styles/ComingSoon.css";
import ComingSoon from "./components/ComingSoon";

export default function App() {
  return <ComingSoon />;
}
